import { getBlacToken } from './blacApi';
import { LoginRequest, LoginResponse } from './authApi';
import { API } from '../global/global';

export const loginBlacApi = async (credentials: LoginRequest): Promise<LoginResponse> => {
  console.log('🔐 Iniciando login para Skyangel...');
  
  try {
    // Hacer petición al backend real
    const response = await fetch(`${API}/loginca`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error en el login');
    }

    const data = await response.json();
    console.log('✅ Login exitoso desde backend');

    // LIMPIAR localStorage antes de empezar
    console.log('🧹 Limpiando tokens anteriores...');
    localStorage.removeItem('blac_token');
    localStorage.removeItem('blac_token_timestamp');
    localStorage.removeItem('blac_available');

    // Obtener token FRESCO de Blac
    console.log('🔄 Obteniendo token FRESCO de Blac API...');
    let blacToken = null;
    let blacAvailable = false;

    try {
      blacToken = await getBlacToken();
      blacAvailable = true;
      console.log('✅ Token FRESCO de Blac obtenido exitosamente');
      console.log('🎯 Token length:', blacToken.length);
    } catch (error) {
      console.error('❌ Error obteniendo token FRESCO de Blac:', error);
      
      // Si no se puede obtener el token de Blac, continuar sin él
      console.warn('⚠️ Continuando sin token de Blac');
      blacAvailable = false;
    }

    console.log('🎉 Login completado');

    // Mapear la respuesta del backend al formato esperado por el frontend
    return {
      user: data.data.usuario,
      token: data.data.token,
      role: data.data.rol,
      permissions: data.data.permisos || [],
      permisos: data.data.permisos || [],
      nivel: data.data.nivel || 0,
      plataforma: data.data.plataforma,
      onasset_token: data.data.onasset_token,
      onasset_available: data.data.onasset_available || false,
      blac_token: blacToken,
      blac_available: blacAvailable
    };

  } catch (error) {
    console.error('❌ Error en login Skyangel:', error);
    
    if (error instanceof Error) {
      throw new Error(error.message);
    }
    
    throw new Error('Error desconocido en el login');
  }
};
